export const reviewTypeEnum = {
    AGENCY: 'review-agency',
    ADMIN: 'review-admin',
    ADMIN_PHOTOGRAPHERS: 'admin-photographers',
    ADMIN_MEDIA: 'admin-media',
    AGENCY_PHOTOGRAPHERS: 'agency-photographers',
    AGENCIES: 'agencies',
}
